// import Web3 from './web3.min.js';
import Web3 from 'web3/dist/web3.min.js';
// import Web3 from 'web3';
import { ethers } from 'ethers';
import { NotificationManager } from 'react-notifications'

// const { gameContractABI, metasinoTokenABI } = require('./abi.js');
const gameContractABI = require('./abi/game.json');
const metasinoTokenABI = require('./abi/metasino.json');


// Unpkg imports
const metasinoContractAddress = "0xa26af01b094a8683a3b8c1ff7ce966176343c549";
const gameContractAddress = "0x74fcf0474D25EDde46Eb7Cee12472f995d9Fc88d";
let metasinoContract = null;
let gameContract = null;
// Chosen wallet provider given by the dialog window
let provider;


export const onConnect = () => {
    return connectWallet();
}

const loadContracts = async () => {
    if (metasinoContract === null) {
        try {
            metasinoContract = new window.web3.eth.Contract(metasinoTokenABI, metasinoContractAddress);
            window.metasinoContract = metasinoContract;
        } catch (error) {
            metasinoContract = null;
            console.log('metasinoContract load error: ', error);
        }
    }

    if (gameContract === null) {
        try {
            gameContract = new window.web3.eth.Contract(gameContractABI, gameContractAddress);
            window.gameContract = gameContract;
        } catch (error) {
            gameContract = null;
            console.log('usdt token contract load error: ', error);
        }
    }
}

export const loadWeb3 = async () => {
    if (window.ethereum) {
        window.web3 = new Web3(window.ethereum);
        window.web3.eth.handleRevert = true;
    } else if (window.web3) {
        window.web3 = new Web3(window.web3.currentProvider);
        window.web3.eth.handleRevert = true
    } else {
        window.alert(
            "Non-Ethereum browser detected. You should consider trying MetaMask!"
        );
        return;
    }

    loadContracts();

    window.ethereum.on('chainChanged', function (chainId) {

    });
};

export const getConnectedNetworkId = async () => {
    if (window.web3 && window.web3.eth) {
        return await window.web3.eth.getChainId();
    }

    return 0;
}

export const connectWallet = async () => {
    if (window.ethereum) {
        try {
            const addressArray = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const obj = {
                status: "Metamask successfuly connected.",
                address: addressArray[0],
            };
            return obj;
        } catch (err) {
            return {
                address: "",
                status: "Something went wrong: " + err.message,
            };
        }
    }
    else {
        return {
            address: "",
            status: (
                <span>
                    <p>
                        {" "}
                        🦊{" "}
                        <a target="_blank" rel="noreferrer" href={`https://metamask.io/download.html`}>
                            You must install Metamask, a virtual BSC wallet, in your
                            browser.
                        </a>
                    </p>
                </span>
            ),
        };
    }
};

export const getCurrentWalletConnected = async () => {
    if (window.ethereum) {
        try {
            const addressArray = await window.ethereum.request({
                method: "eth_accounts",
            });
            if (addressArray.length > 0) {
                return {
                    address: addressArray[0],
                    status: "Fill in the text-field above.",
                };
            } else {
                return {
                    address: "",
                    status: "🦊 Connect to Metamask using the top right button.",
                };
            }
        } catch (err) {
            return {
                address: "",
                status: "Something went wrong: " + err.message,
            };
        }
    } else {
        return {
            address: "",
            status: (
                <span>
                    <p>
                        {" "}
                        🦊{" "}
                        <a target="_blank" rel="noreferrer" href={`https://metamask.io/download.html`}>
                            You must install Metamask, a virtual BSC wallet, in your
                            browser.
                        </a>
                    </p>
                </span>
            ),
        };
    }
};


export const getCurrentWallet = async () => {
    const web3 = window.web3;
    try {
        let accounts = await web3.eth.getAccounts();
        let accountBalance = await web3.eth.getBalance(accounts[0]);
        accountBalance = web3.utils.fromWei(accountBalance);
        return {
            success: true,
            account: accounts[0],
            balance: accountBalance
        }
    } catch (error) {
        return {
            success: false,
            result: "Something went wrong: " + error.message
        }
    }
}

export const deposit = async (amount) => {
    if (!window.web3 || !gameContract || !metasinoContract) {
        return false;
    }

    const curWallet = await getCurrentWallet();
    if (curWallet.success == false) {
        return false;
    }

    let bnAmount = window.web3.utils.toWei("" + amount, 'ether');
    const maxVal = await getMetasinoTokenBalance();

    if (Number(maxVal) * 0.8 < Number(bnAmount)) {
        NotificationManager.error("Your withdraw amount exeeded max balanece of metasino");
        return false;
    }

    try {
        const allowance = await metasinoContract.methods
            .allowance(curWallet.account, gameContractAddress)
            .call();
        var allowance_normal = window.web3.utils.fromWei("" + allowance, 'ether');

        if (Number(allowance_normal) < amount) {
            await metasinoContract.methods
                .approve(
                    gameContractAddress,
                    "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
                )
                .send({ from: curWallet.account });
        }

        await gameContract.methods.deposit(bnAmount).send({ from: curWallet.account });
        NotificationManager.success('success deposit!');
    } catch (error) {
        NotificationManager.error('falied deposit!');
        console.log('deposit error : ', error);
        return false;
    }

    return true;
}


export const withdraw = async (amount) => {
    if (!window.web3 || !gameContract || !metasinoContract) {
        return false;
    }

    const curWallet = await getCurrentWallet();
    if (curWallet.success == false) {
        return false;
    }
    const maxVal = await getChipsBalance();
    let bnAmount = window.web3.utils.toWei("" + amount, 'ether');
    if (Number(maxVal) * 0.8 < Number(bnAmount)) {
        NotificationManager.error("Your withdraw amount exeeded max balanece of chips");
        return false;
    }
    try {
        await gameContract.methods.withdrawForUser(bnAmount).send({ from: curWallet.account });
        NotificationManager.success("success withdraw!");
    } catch (error) {
        NotificationManager.error("failed withdraw!");
        return false;
    }

    return true;
}


export const getChipsBalance = async () => {
    if (!window.web3 || !gameContract || !metasinoContract) {
        return 0;
    }

    const curWallet = await getCurrentWallet();
    if (curWallet.success == false) {
        return 0;
    }

    try {
        let res = await gameContract.methods.getChips(curWallet.account).call();
        return res;
    } catch (error) {
        return 0;
    }

    return 0;
}


export const getMetasinoTokenBalance = async () => {
    if (!window.web3 || !gameContract || !metasinoContract) {
        return 0;
    }

    const curWallet = await getCurrentWallet();
    if (curWallet.success == false) {
        return 0;
    }

    try {
        return await metasinoContract.methods.balanceOf(curWallet.account).call();
    } catch (error) {
        return 0;
    }

    return 0;
}

